module.exports = __webpack_public_path__ + "img/OEHU_DECENTRALISED.86082f4f.svg";